<template>
    <div class="box m-b-0">
        <div class="box-header">
            <h3>Uczestnicy: {{ room.name }}</h3>
        </div>
        <div class="box-tool">
            <ul class="nav">
                <li class="nav-item inline icon-with-desc">
                    <a class="nav-link text-muted" @click="$emit('close')">
                        <i class="material-icons md-18">clear</i>
                        <span class="icon-desc">ESC</span>
                    </a>
                </li>
            </ul>
        </div>
        <hr class="m-y-0"/>
        <div class="box-body">
            <div class="form-group">
                <label>Obecni uczestnicy</label>
                <div class="chat-member-row" v-for="member in room.members" :key="String(member.userId)">
                    <span>
                        {{ getName(member.userId) }}
                        <small v-if="member.isOwner" class="text-muted">(właściciel)</small>
                    </span>
                    <a href="#" v-if="canRemove(member)" @click.prevent="removeMember(member)" title="Usuń z pokoju">
                        <i class="material-icons md-18 text-red">person_remove</i>
                    </a>
                </div>
            </div>
            <div class="form-group">
                <label>Zaproś kolejnych</label>
                <input type="text" class="form-control m-b-xs" v-model="filter" placeholder="Szukaj..."/>
                <div class="chat-user-picker">
                    <label class="chat-user-option" v-for="user in invitableUsers" :key="user._id">
                        <input type="checkbox" :value="String(user._id)" v-model="selected"/>
                        <span class="m-l-xs">{{ user.name }}</span>
                    </label>
                    <div v-if="!invitableUsers.length" class="text-muted">Wszyscy aktywni użytkownicy są już w pokoju</div>
                </div>
            </div>
            <button class="btn blue none-radius" :disabled="!selected.length || isSaving" @click="invite">Zaproś</button>
        </div>
    </div>
</template>

<script>
import Api from '../../Api.js';
import ChatManager from '../../ChatManager.js';
import SystemUsersManager from '../../SystemUsersManager.js';

export default {
    name: 'ChatInviteModal',
    props: {
        room: Object
    },
    data: function() {
        return {
            filter: '',
            selected: [],
            systemUsers: [],
            isSaving: false,
        };
    },
    created: async function() {
        this.systemUsers = await SystemUsersManager.getSystemUsers();
    },
    computed: {
        invitableUsers: function() {
            const memberIds = new Set((this.room.members || []).map(m => String(m.userId)));
            const q = this.filter.toLowerCase();
            return (this.systemUsers || [])
                .filter(u => !memberIds.has(String(u._id)) && !u.isRemoved && !u.isDisabled)
                .filter(u => !q || (u.name || '').toLowerCase().includes(q))
                .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        }
    },
    methods: {
        getName: function(userId) {
            return SystemUsersManager.getName(userId);
        },
        canRemove: function(member) {
            const me = String(ChatManager.getMyUserId());
            const myEntry = (this.room.members || []).find(m => String(m.userId) == me);
            const isOwner = myEntry && myEntry.isOwner;
            return isOwner && String(member.userId) != me;
        },
        removeMember: async function(member) {
            const ok = await this.$h.confirm('Usunąć ' + this.getName(member.userId) + ' z pokoju?');
            if (!ok) return;
            try {
                const updated = await Api.chat.removeMember(this.room._id, member.userId);
                this.room.members = updated.members;
            } catch (e) {
                this.$h.commonApiError(e);
            }
        },
        invite: async function() {
            if (!this.selected.length || this.isSaving) return;
            this.isSaving = true;
            try {
                const updated = await Api.chat.invite(this.room._id, this.selected);
                this.room.members = updated.members;
                this.selected = [];
            } catch (e) {
                this.$h.commonApiError(e);
            } finally {
                this.isSaving = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.chat-member-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3px 0;
}

.chat-user-picker {
    max-height: 180px;
    overflow-y: auto;
    border: 1px solid var(--dm-border, #e9ecef);
    border-radius: 4px;
    padding: 6px 10px;
}

.chat-user-option {
    display: block;
    margin: 0;
    padding: 3px 0;
    font-weight: 400;
    cursor: pointer;
}
</style>
